import React, { useState } from 'react';
import { Button } from "react-bootstrap";

export const TermsAndConditions = () => {
    const [pdfUrl, setPdfUrl] = useState(null);
    const [pdfName, setPdfName] = useState(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file && file.type === 'application/pdf') {
            const fileUrl = URL.createObjectURL(file);
            setPdfUrl(fileUrl);
            setPdfName(file.name);
        } else {
            alert('Please upload a valid PDF file.');
        }
    };

    const onclickPDF = () => {
        if (pdfUrl) {
            window.open(pdfUrl, '_blank');
        }
    };

    const cancelUpload = () => {
        setPdfUrl('');
        setPdfName('');
    }

    return (
        <div className="mystery-reward h-100 p-5" style={{ overflowY: "scroll" }}>
            <h3>Mystery Rewards</h3>
            <h6 className='mt-3'>Upload Documents</h6>
            <div className="d-flex flex-column align-items-center justify-content-center clickable" style={{ border: "1px solid", padding: "20px" }}>
                <div className='font-weight-bold'>Upload Files</div>

                {
                    pdfUrl ? 
                        <div className='mt-3'>{pdfName}</div> : 
                        <>
                            <label htmlFor="pdf-upload" className="d-flex flex-column align-items-center justify-content-center p-3 mt-3 clickable"
                            style={{ border: "1px dashed", cursor: "pointer", width: "100%", textAlign: "center" }}>
                                <img src={`${process.env.PUBLIC_URL}/static/images/upload.png`} alt="default" height="75" width="75" />
                                <div className="d-flex flex-column">
                                    <div>Drop files here</div>
                                    <div>Supported format: PDF</div>
                                </div>
                                <div>OR</div>
                                <div>Browse a files</div>
                            </label>
                            <input type="file" accept="application/pdf" id="pdf-upload" style={{ display: "none" }} onChange={handleFileChange} />
                        </>
                }
                <div className="d-flex align-items-center justify-content-between mt-3">
                    { pdfUrl ? <Button className='d-flex align-items-center justify-content-center' onClick={() => {onclickPDF()}}>Preview</Button> : ''}
                    <Button onClick={() => {cancelUpload()}} style={{ marginLeft: "10px" }}>Cancel</Button>
                    <Button style={{ marginLeft: "10px" }}>Upload</Button>
                </div>
            </div>
        </div>
    )
}
export default TermsAndConditions;
